module.exports = __webpack_public_path__ + "static/img/qItem3-img3.9ece265.png";


//////////////////
// WEBPACK FOOTER
// ./static/about/qItem3-img3.png
// module id = 71V9
// module chunks = 1